import { Box, Image, Spacer, Text, useWindowDimensions } from '@jfs/ui-new'
import { openPlayStore } from '../../comps/ProductsMegaMenu'
import { staticStrings } from '../../static/staticStrings'
import usePadding from '../../util/usePadding'
import { isMobileWidth } from '../../util/util'

export const SafeSecureSection = () => {
  const resPadding = usePadding()
  const viewportWidth = useWindowDimensions()
  const isMobile = isMobileWidth(viewportWidth)
  return (
    <Box ph={resPadding} justify={'space-between'} flexDirection={isMobile ? 'column-reverse' : 'row'} align={'center'}>
      <Box
        flexDirection={'column'}
        justify={'center'}
        f={isMobile ? undefined : 0.5}
        paddingRight={isMobile ? 0 : 16}
        pt={isMobile ? 48 : undefined}>
        <Text
          title={staticStrings.consumerSafeSecure}
          fontFamily={'jiotype-black'}
          color={'WHITE'}
          fontSize={isMobile ? 24 : 64}
          lineHeight={isMobile ? 36 : 80}
          letterSpacing={-2.5}
        />
        <Spacer size={isMobile ? 16 : 32} />
        <Text
          title={staticStrings.consumerEasiest}
          fontFamily={isMobile ? 'jiotype-medium' : 'jiotype-light'}
          color={'WHITE'}
          opacity={isMobile ? 0.9 : 1}
          fontSize={isMobile ? 14 : 24}
          lineHeight={isMobile ? 24 : 36}
          letterSpacing={-0.48}
        />
        <Box flexDirection={'row'} gap={isMobile ? 16 : 8} pv={isMobile ? 32 : 40}>
          <Box onPress={openPlayStore} underlayColor="TRANSPARENT">
            <Image
              source={require('../../assets/images/play-store.png')}
              width={isMobile ? 108 : 162}
              height={isMobile ? 32 : 48}
              resizeMode={'contain'}
            />
          </Box>
          <Box onPress={openPlayStore} underlayColor="TRANSPARENT">
            <Image
              source={require('../../assets/images/apple-store.png')}
              width={isMobile ? 96 : 162}
              height={isMobile ? 32 : 48}
              resizeMode={'contain'}
            />
          </Box>
          <Box onPress={openPlayStore} underlayColor="TRANSPARENT">
            <Image
              source={require('../../assets/images/kaiOS.png')}
              width={isMobile ? 68 : 102}
              height={isMobile ? 32 : 48}
              resizeMode={'contain'}
            />
          </Box>
        </Box>
      </Box>
      <Box f={isMobile ? undefined : 0.5}>
        <Image
          source={require('../../assets/images/jiopayconsumer.png')}
          width={isMobile ? '100vw' : '100%'}
          resizeMode={'center'}
          height={isMobile ? 250 : 590}
        />
      </Box>
    </Box>
  )
}
